import type { AuthProvider } from "api";

type ProviderCopy = {
  mark: string;
  title: string;
  subtitle: string;
  link: string;
  linkText: string;
  footnote: string;
};

const COPY: Record<AuthProvider, ProviderCopy> = {
  google: {
    mark: "G",
    title: "Signed in with Google",
    subtitle: "This account uses Google Sign-In, so there is no password to change here.",
    link: "https://myaccount.google.com/security",
    linkText: "Manage in Google",
    footnote: "Your sign-in email is managed by Google.",
  },
  github: {
    mark: "GH",
    title: "Signed in with GitHub",
    subtitle: "This account uses GitHub Sign-In, so there is no password to change here.",
    link: "https://github.com/settings/emails",
    linkText: "Manage in GitHub",
    footnote: "Your sign-in email is managed by GitHub and may be private.",
  },
};

/**
 * Replaces the password form for accounts that never had a password, and
 * points to where the provider lets the email be changed.
 */
export const SignInMethodCard = ({ provider, email }: { provider: AuthProvider; email: string }) => {
  const copy = COPY[provider];

  return (
    <div className="pcx">
      <div className="pcx__top">
        <div>
          <div className="pcx__h">Sign-in method</div>
          <p className="pcx__sub">{copy.subtitle}</p>
        </div>
      </div>

      <div className="pc-goog">
        <span className="pc-goog__mark">{copy.mark}</span>
        <div className="pc-goog__id">
          <b>{copy.title}</b>
          <span>{email}</span>
        </div>
        <div className="pc-key__acts">
          <a className="pcbtn" href={copy.link} target="_blank" rel="noopener noreferrer">
            {copy.linkText}
          </a>
        </div>
      </div>

      <p className="pc-foot">{copy.footnote}</p>
    </div>
  );
};
